import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
	// mode: "history",
	routes: [{
			path: '/',
			// redirect: '/eduweb',
			name: 'home',
			component: () => import("@/views/home/index"),
		},
		{
			path: '/course',
			name: 'course',
			component: () => import("@/views/course/course"),
		},
		{
			path: '/website',
			name: 'website',
			component: () => import("@/views/website/website"),
		},
		{
			path: '/websiteDetail',
			name: 'websiteDetail',
			component: () => import("@/views/website/websiteDetail"),
		},
		{
			path: '/buys',
			name: 'buys',
			component: () => import("@/views/course/buys"),
		},
		{
			path: '/spotCourse',
			name: 'spotCourse',
			component: () => import("@/views/course/spotCourse"),
		},
		{
			path: '/soliveCourse',
			name: 'soliveCourse',
			component: () => import("@/views/course/soliveCourse"),
		},
		{
			path: '/live',
			name: 'live',
			component: () => import("@/views/course/live"),
		},
		{
			path: '/lectureCourse',
			name: 'lectureCourse',
			component: () => import("@/views/course/lectureCourse"),
		},
		{
			path: '/question',
			name: 'question',
			component: () => import("@/views/question/question"),
		},
		{
			path: '/questionDetail',
			name: 'questionDetail',
			component: () => import("@/views/question/questionDetail"),
		},
		{
			path: '/doExercise',
			name: 'doExercise',
			component: () => import("@/views/question/doExercise"),
		},
		{
			path: '/testResult',
			name: 'testResult',
			component: () => import("@/views/question/testResult"),
		},
		{
			path: '/onlineTest',
			name: 'onlineTest',
			component: () => import("@/views/question/onlineTest"),
		},
		{
			path: '/onlineAnalysis',
			name: 'onlineAnalysis',
			component: () => import("@/views/question/onlineAnalysis"),
		},
		{
			path: '/information',
			name: 'information',
			component: () => import("@/views/information/information"),
		},
		{
			path: '/informationDetail',
			name: 'informationDetail',
			component: () => import("@/views/information/informationDetail"),
		},
		{
			path: '/community',
			name: 'community',
			component: () => import("@/views/community/community"),
		},
		{
			path: '/postDetail',
			name: 'postDetail',
			component: () => import("@/views/community/postDetail"),
		},
		{
			path: '/post',
			name: 'post',
			component: () => import("@/views/community/post"),
		},
		{
			path: '/shopping',
			name: 'shopping',
			component: () => import("@/views/shopping/shopping"),
		},
		{
			path: '/personal',
			name: 'personal',
			component: () => import("@/views/personal/personal"),
		},
		{
			path: '/couponCentre',
			name: 'couponCentre',
			component: () => import("@/views/personal/couponCentre"),
		},
		{
			path: '/cartAccount',
			name: 'cartAccount',
			component: () => import("@/views/personal/cartAccount"),
		},
		{
			path: '/orderDetail',
			name: 'orderDetail',
			component: () => import("@/views/personal/orderDetail"),
		},
		{
			path: '/couponCourse',
			name: 'couponCourse',
			component: () => import("@/views/personal/couponCourse"),
		},
		{
			path: '/login',
			name: 'login',
			component: () => import("@/views/login/login"),
		},
		{
			path: '/reg',
			name: 'reg',
			component: () => import("@/views/login/reg"),
		},
		{
			path: '/forgetPass',
			name: 'forgetPass',
			component: () => import("@/views/login/forgetPass"),
		},
		{
			path: '/activityCourse',
			name: 'activityCourse',
			component: () => import("@/views/course/activityCourse"),
		},
		{
			path: '/tenderWrite',
			name: 'tenderWrite',
			component: () => import("@/views/tender/tenderWrite"),
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js